import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Breadcrumb from './components/Breadcrumb';
import Home from './pages/Home';
import Productions from './pages/Productions';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import Pricing from './pages/Pricing';
import Impressum from './pages/Impressum';
import ThankYou from './pages/ThankYou';
import { Toaster } from './components/ui/sonner';

function App() {
  useEffect(() => {
    // Load Koalendar widget
    window.Koalendar = window.Koalendar || function() {
      (window.Koalendar.props = window.Koalendar.props || []).push(arguments);
    };

    const script = document.createElement('script');
    script.src = 'https://koalendar.com/assets/widget.js';
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      window.Koalendar('widget', {
        url: 'https://koalendar.com/e/podcast-session',
        text: 'Schedule a meeting',
        shape: 'rounded-full',
        backgroundColor: '#ffff31',
        textColor: '#000000',
        position: 'bottom-right',
        icon: 'calendar'
      });
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Breadcrumb />
        <Routes>
          {/* Redirect root to English */}
          <Route path="/" element={<Navigate to="/en" replace />} />
          
          {/* English Routes */}
          <Route path="/en" element={<Home />} />
          <Route path="/en/productions" element={<Productions />} />
          <Route path="/en/pricing" element={<Pricing />} />
          <Route path="/en/blog" element={<Blog />} />
          <Route path="/en/blog/:slug" element={<BlogPost />} />
          <Route path="/en/contact" element={<Contact />} />
          <Route path="/en/impressum" element={<Impressum />} />
          <Route path="/en/thankyou" element={<ThankYou />} />
          
          {/* German Routes */}
          <Route path="/de" element={<Home />} />
          <Route path="/de/productions" element={<Productions />} />
          <Route path="/de/pricing" element={<Pricing />} />
          <Route path="/de/blog" element={<Blog />} />
          <Route path="/de/blog/:slug" element={<BlogPost />} />
          <Route path="/de/contact" element={<Contact />} />
          <Route path="/de/impressum" element={<Impressum />} />
          <Route path="/de/danke" element={<ThankYou />} />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/en" replace />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;